import { createKeywordTypeNode } from 'typescript';
import { RequestModel } from '../models/RequestModel';

export class TestFill{
    fillRequest(r: RequestModel): void{
        r.firstName = 'John';
        r.lastName = 'Walters';
        r.email = 'jwalters@contoso.com';
        r.primaryPhone = '7201112233';
        r.primaryPhoneType = "Home";

        r.mailAddress = '852 S Jason St';
        r.mailCity = 'Denver';
        r.mailState = 'Colorado';
        r.mailZip = '80223';

        r.plantingAddress = '852 S Jason St';
        r.plantingCity = 'Denver';
        r.plantingState = 'Colorado';
        r.plantingZip = '80223';
        r.isTargetNeighborhood = true;
        r.neighborhoodDesc = 'Athmar Park';
        r.initialsAcceptAbove = 'AA';
        r.initialsReleaseOfLiability = 'BB';


        r.neighborhoodId = 3;
        r.distributionId = 1;

        r.cardNumber = '4007000000027';
        // r.paymentDate = new Date(new Date().getUTCDate()); // new Date('Sun May 11,2014').toLocaleDateString('en-US');
        r.expirationDate = '12/23';
        r.expirationMonth = '12';
        r.expirationYear = 2023;
        r.cvv = '999';

        r.couponCode = '';
        r.paymentAmount = 53;
        r.treeTotalAmount = 53;
        r.amountDueNow = 53;
        r.waitListAmount = 20;
    }

    // fillPay(p: PaymentPrepModel): void {
    //     p.firstName = 'John';
    //     p.lastName = 'Walters';

    //     p.mailAddress = '852 S Jason St, Denver, Colorado 80223, United States';
    //     p.mailCity = 'Denver';
    //     p.mailState = 'Colorado';
    //     p.mailZip = '80223';

    //     p.cardNumber = '5424000000000015';
    //     p.paymentDate = new Date(new Date().getUTCDate()); // new Date('Sun May 11,2014').toLocaleDateString('en-US');
    //     p.expirationDate = '12/2020';
    //     p.cvv = '999';

    //     p.paymentAmount = 53;
    //     p.treeTotalAmount = 53;
    //     p.amountDueNow = 53;
    //     p.waitListAmount=20;

    // }
}
